import type { TModule } from '@modules/core/types';

import { OPS_HUB_ROUTE_PATHS } from './config';
import { DEBT_ENGINE_ROUTES } from './debt-engine';
import { FX_CONFIGURATION_ROUTES } from './fx-configuration';
import { GATEWAY_ROUTING_ROUTES } from './gateway-routing';
import { PAYMENT_METHODS_ROUTES } from './payment-methods';
import { RULES_CONFIG_ROUTES } from './rules-config';
import { WITHDRAWAL_METHOD_CONFIG_ROUTES } from './withdrawal-method-config';

const opsHubModule: TModule = {
  id: 'ops-hub',
  fallbackRoute: [OPS_HUB_ROUTE_PATHS.debtEngine],
  permissions: {
    roles: [],
    scopes: ['debt-engine', 'fx-configuration', 'gateway-routing', 'payment-methods', 'rules-config', 'withdrawal-method-config'],
  },
  isPublic: false,
  routes: [
    ...DEBT_ENGINE_ROUTES,
    ...FX_CONFIGURATION_ROUTES,
    ...GATEWAY_ROUTING_ROUTES,
    ...PAYMENT_METHODS_ROUTES,
    ...RULES_CONFIG_ROUTES,
    ...WITHDRAWAL_METHOD_CONFIG_ROUTES,
  ],
};

export { OPS_HUB_ROUTE_PATHS as OpsHubRoutePaths };

export default opsHubModule;
